module.exports = __webpack_public_path__ + "static/media/door-is-wrong.7ae5d464.mp3";